"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Warning = exports.Error = exports.Success = exports.Basic = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _propTypes = require("prop-types");

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var css = _interopRequireWildcard(require("./Label.styles"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Basic = function Basic(_ref) {
  var variant = _ref.variant,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, ["variant", "label"]);

  return (0, _jsxRuntime.jsx)(_Chip["default"], _objectSpread({
    css: css.chip(variant),
    label: label
  }, props));
};

exports.Basic = Basic;

var Success = function Success(_ref2) {
  var label = _ref2.label,
      props = _objectWithoutProperties(_ref2, ["label"]);

  return (0, _jsxRuntime.jsx)(Basic, _objectSpread({
    variant: "success",
    label: label
  }, props));
};

exports.Success = Success;

var Error = function Error(_ref3) {
  var label = _ref3.label,
      props = _objectWithoutProperties(_ref3, ["label"]);

  return (0, _jsxRuntime.jsx)(Basic, _objectSpread({
    variant: "error",
    label: label
  }, props));
};

exports.Error = Error;

var Warning = function Warning(_ref4) {
  var label = _ref4.label,
      props = _objectWithoutProperties(_ref4, ["label"]);

  return (0, _jsxRuntime.jsx)(Basic, _objectSpread({
    variant: "warning",
    label: label
  }, props));
};

exports.Warning = Warning;
Basic.propTypes = {
  /**
   * The color to render the Chip in
   */
  variant: (0, _propTypes.oneOf)([null, 'primary', 'success', 'error', 'warning']),

  /**
   * The string or JSX to display in the label.
   */
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
Basic.defaultProps = {
  variant: null,
  label: ''
};
Success.propTypes = {
  /**
   * The string or JSX to display in the label.
   */
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
Success.defaultProps = {
  label: ''
};
Error.propTypes = {
  /**
   * The string or JSX to display in the label.
   */
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
Error.defaultProps = {
  label: ''
};
Warning.propTypes = {
  /**
   * The string or JSX to display in the label.
   */
  label: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.node])
};
Warning.defaultProps = {
  label: ''
};